import * as React from "react";
import { debounce } from "lodash";

const { Component } = React;

import * as UserStore from "../users/UserStore";
import * as OrganizationStore from "./OrganizationStore";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from "reactstrap";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import axios from "../general/HttpClient";

interface OrganizationRegistrationLinksState {
    links: Array<any>;
    showAddModal: boolean;
    showDisableModal: boolean;
    showEnableModal: boolean;
    showSendModal: boolean;
    linkToDisable: any;
    linkToEnable: any;
    linkToSend: any;
    membershipType: number;
    registerLinkRecipients: Array<any>;
    recipientName: string;
    recipientEmail: string;
    recipientMessage: string;
}

interface OrganizationRegistrationLinksProps {
    organization: string;
}

let contextSubscriptionId = "";

let isEmail = (email) => {
    return /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/gim.test(email);
};

export default class OrganizationRegistrationLinks extends Component<OrganizationRegistrationLinksProps, OrganizationRegistrationLinksState> {
    constructor(props) {
        super(props);
        this.state = {
            links: [],
            showAddModal: false,
            showDisableModal: false,
            showEnableModal: false,
            showSendModal: false,
            linkToDisable: undefined,
            linkToEnable: undefined,
            linkToSend: undefined,
            membershipType: 0,
            registerLinkRecipients: [],
            recipientName: "",
            recipientEmail: "",
            recipientMessage: "",
        };
    }

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getLinks();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getLinks() {
        OrganizationStore.ListRegisterLinks(this.props.organization).then((response) => {
            this.setState({ links: response.data || [], showAddModal: false, showDisableModal: false, showEnableModal: false });
        });
    }

    handleMembershipTypeChange = (e) => {
        var type = e.target.value;
        this.setState({ membershipType: +type });
    };

    toggleAddModal = () => {
        this.setState((prevState) => ({ showAddModal: !prevState.showAddModal }));
    };

    startCreateRegisterLink = () => {
        this.setState({
            showAddModal: true,
        });
    };

    completeCreateRegisterLink = () => {
        if (this.state.membershipType != null) {
            OrganizationStore.CreateRegisterLink(this.props.organization, this.state.membershipType).then(() => {
                this.getLinks();
            });
        }
    };

    toggleDisableModal = () => {
        this.setState((prevState) => ({ showDisableModal: !prevState.showDisableModal }));
    };

    startDisableRegisterLink = (link) => () => {
        this.setState({
            linkToDisable: link,
            showDisableModal: true,
        });
    };

    completeDisableRegisterLink = () => {
        if (this.state.linkToDisable.id) {
            OrganizationStore.DisableRegisterLink(this.props.organization, this.state.linkToDisable.id).then(() => {
                this.getLinks();
            });
        }
    };

    toggleEnableModal = () => {
        this.setState((prevState) => ({ showEnableModal: !prevState.showEnableModal }));
    };

    startEnableRegisterLink = (link) => () => {
        this.setState({
            linkToEnable: link,
            showEnableModal: true,
        });
    };

    completeEnableRegisterLink = () => {
        if (this.state.linkToEnable.id) {
            OrganizationStore.EnableRegisterLink(this.props.organization, this.state.linkToEnable.id).then(() => {
                this.getLinks();
            });
        }
    };

    copyLink = (link) => () => {
        var url = window.location.origin + "/Account/Register?token=" + link.token;
        // @ts-ignore
        navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
            if (result.state == "granted" || result.state == "prompt") {
                navigator.clipboard.writeText(url).then(
                    function () {
                        /* clipboard successfully set */
                    },
                    function () {
                        /* clipboard write failed */
                    }
                );
            }
        });
    };

    toggleSendLinkModal = () => {
        this.setState((prevState) => ({ showSendModal: !prevState.showSendModal }));
    };

    startSendRegisterLink = (link) => () => {
        this.setState({
            linkToSend: link,
            showSendModal: true,
            recipientName: "",
            recipientEmail: "",
            recipientMessage: "",
            registerLinkRecipients: [],
        });
    };

    completeSendRegisterLink = () => {
        if (this.state.linkToSend.id) {
            OrganizationStore.SendRegisterLink(this.state.linkToSend, this.state.registerLinkRecipients, this.state.recipientMessage).then(() => {
                this.setState({ showSendModal: false });
            });
        }
    };

    addRegisterLinkRecipient = () => {
        this.setState((prevState) => {
            let registerLinkRecipients = prevState.registerLinkRecipients;

            registerLinkRecipients.push({
                name: this.state.recipientName,
                email: this.state.recipientEmail,
            });

            return {
                registerLinkRecipients,
                recipientName: "",
                recipientEmail: "",
            };
        });
    };

    removeRegisterLinkRecipient = (recipient) => () => {
        this.setState((prevState) => {
            let registerLinkRecipients = prevState.registerLinkRecipients.filter((r) => r != recipient);

            return {
                registerLinkRecipients,
            };
        });
    };

    handRecipientNameChange = (e) => {
        let value = e.target.value;
        this.setState({ recipientName: value });
    };

    handRecipientEmailChange = (e) => {
        let value = e.target.value;
        this.setState({ recipientEmail: value });
    };

    handRecipientMessageChange = (e) => {
        let value = e.target.value;
        this.setState({ recipientMessage: value });
    };

    render() {
        return (
            <div>
                <table className="table">
                    <thead>
                        <tr>
                            <th style={{ width: "40%" }}>Type</th>
                            <th style={{ width: "10%" }}></th>
                            <th style={{ width: "50%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.links.length > 0 &&
                            this.state.links.map((link) => {
                                return (
                                    <tr key={link.id} className={link.enabled ? "" : "text-muted"}>
                                        <td>{OrganizationStore.MembershipType(link.membershipType)}</td>
                                        <td>{link.usersRegistered} users register</td>
                                        {link.enabled && (
                                            <td>
                                                <button className="btn btn-outline-dark btn-sm" onClick={this.startSendRegisterLink(link)}>
                                                    Send Link
                                                </button>
                                                <button className="btn btn-outline-dark btn-sm" onClick={this.copyLink(link)}>
                                                    Copy Link
                                                </button>
                                                <button className="btn btn-outline-warning btn-sm" onClick={this.startDisableRegisterLink(link)}>
                                                    Disable
                                                </button>
                                            </td>
                                        )}
                                        {!link.enabled && (
                                            <td>
                                                <div>Disabled</div>
                                                <button className="btn btn-outline-success btn-sm" onClick={this.startEnableRegisterLink(link)}>
                                                    Enable
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        <tr>
                            <td colSpan={3}>
                                <a href="#" onClick={this.startCreateRegisterLink}>
                                    Add Register Link
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <Modal isOpen={this.state.showAddModal} toggle={this.toggleAddModal} centered={true}>
                    <ModalHeader toggle={this.toggleAddModal}>Manage Organization Membership</ModalHeader>
                    <ModalBody>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Type</label>
                            <div className="col-sm-9 pl-0">
                                <Input type="select" name="type" value={this.state.membershipType} onChange={this.handleMembershipTypeChange}>
                                    <option value="0">Staff</option>
                                    <option value="1">Student</option>
                                    <option value="2">Parent</option>
                                    <option value="3">Guest</option>
                                </Input>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.completeCreateRegisterLink}>
                            Add
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showDisableModal} toggle={this.toggleDisableModal} centered={true}>
                    <ModalHeader toggle={this.toggleDisableModal}>Manage Organization Membership</ModalHeader>
                    <ModalBody>
                        {this.state.linkToDisable && (
                            <div>
                                Confirm disabling {OrganizationStore.MembershipType(this.state.linkToDisable.membershipType)} registration link{" "}
                                <span className="text-muted">({this.state.linkToDisable.id})</span>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.completeDisableRegisterLink}>
                            Disable
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showEnableModal} toggle={this.toggleEnableModal} centered={true}>
                    <ModalHeader toggle={this.toggleEnableModal}>Manage Organization Membership</ModalHeader>
                    <ModalBody>
                        {this.state.linkToEnable && (
                            <div>
                                Confirm enabling {OrganizationStore.MembershipType(this.state.linkToEnable.membershipType)} registration link{" "}
                                <span className="text-muted">({this.state.linkToEnable.id})</span>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.completeEnableRegisterLink}>
                            Enable
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showSendModal} toggle={this.toggleSendLinkModal} centered={true}>
                    <ModalHeader toggle={this.toggleSendLinkModal}>Send Registration Link</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="message">Message</Label>
                            <Input type="text" id="message" value={this.state.recipientMessage} onChange={this.handRecipientMessageChange}></Input>
                        </FormGroup>
                        {this.state.linkToSend && (
                            <div>
                                <table className="table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.registerLinkRecipients.map((recipient, i) => (
                                            <tr key={i}>
                                                <td>{recipient.name}</td>
                                                <td>{recipient.email}</td>
                                                <td>
                                                    <Button color="link" onClick={this.removeRegisterLinkRecipient(recipient)}>
                                                        Remove
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td>
                                                <Input type="text" value={this.state.recipientName} onChange={this.handRecipientNameChange}></Input>
                                            </td>
                                            <td>
                                                <Input type="email" value={this.state.recipientEmail} onChange={this.handRecipientEmailChange}></Input>
                                            </td>
                                            <td>
                                                <Button color="link" disabled={!this.state.recipientName || !isEmail(this.state.recipientEmail)} onClick={this.addRegisterLinkRecipient}>
                                                    Add
                                                </Button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.toggleSendLinkModal}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={this.completeSendRegisterLink} disabled={this.state.registerLinkRecipients.length == 0}>
                            Send
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
